import React, { Fragment } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { GAME_RULES_HELP_KEYS_TURBO } from '../../enums/constants';
import turboHelpImg1 from '../../assets/images/helps/Deal.png';
import turboHelpImg2 from '../../assets/images/helps/Terz.png';
import turboHelpImg3 from '../../assets/images/helps/50.png';
import turboHelpImg4 from '../../assets/images/helps/100.png';
import turboHelpImg5 from '../../assets/images/helps/4_cards.png';
import turboHelpImg6 from '../../assets/images/helps/x2.png';
import { COMBINATIONS_PAYOUTS } from '../../enums/cardTypes';

const sortedTurboImages = {
  1: turboHelpImg1,
  10: turboHelpImg2,
  11: turboHelpImg3,
  12: turboHelpImg4,
  13: turboHelpImg5,
  15: turboHelpImg6,
};

export function HelpPopup() {
  const t = useTranslation();
  return (
    <div className='tb-game-rules-wrapper'>
      {GAME_RULES_HELP_KEYS_TURBO.map((item) => (
        <Fragment key={item}>
          <p className='tb-rules-txt'>{t(`GAME_RULES_P${item + 1}`)}</p>
          {!!sortedTurboImages?.[item] && (
            <div className='c-m-game-rules-img'>
              <img src={sortedTurboImages?.[item]} alt='' />
            </div>
          )}
        </Fragment>
      ))}
      {COMBINATIONS_PAYOUTS.map(({ winType, type, img }) => (
        <div key={winType} className='rules-content-cards'>
          <div className='comb-row-block-col-img'>
            <img src={img} alt='' />
          </div>
          {/* <span className='rules-cards-oval' /> */}
          <span className='items-inner-cards-number'>{t(type)}</span>
        </div>
      ))}
      <p className='tb-rules-txt'>{t(`GAME_RULES_P30`)}</p>
      <p className='tb-rules-txt'>{t(`GAME_RULES_P31`)}</p>
      <p className='tb-rules-txt'>{t(`GAME_RULES_P32`)}</p>
      <p className='tb-rules-txt'>{t(`GAME_RULES_P33`)}</p>
      {COMBINATIONS_PAYOUTS.map(({ winType, type, odd }) => (
        <div key={winType} className='rules-content-cards'>
          <span className='items-inner-cards-number'>{t(type)}</span>
          <span className='rules-cards-oval' />
          <p className='rules-cards-bet-amount'>x{odd}</p>
        </div>
      ))}
      <p className='tb-rules-txt'>RTP 96%</p>
    </div>
  );
}
